import React from 'react';
import Styles from './credit-card-component-styles.scss';
const formatCardNumber = number => {
    if (!number)
        return;
    const formattedNumber = number
        .replace(/\s/g, '')
        .replace(/(\d{4})/g, '$1&nbsp;&nbsp;')
        .trim();
    return formattedNumber;
};
const CreditCardComponent = ({ number, name, expiry, limit }) => {
    return (React.createElement("div", { className: Styles.creditCardComponent },
        React.createElement("div", { className: Styles.creditCardLogo },
            React.createElement("img", { className: Styles.logo1 })),
        React.createElement("div", { className: Styles.creditCardNumber, dangerouslySetInnerHTML: { __html: formatCardNumber(number) } }),
        React.createElement("div", { className: Styles.creditCardDetails },
            React.createElement("div", { className: Styles.item },
                React.createElement("div", { className: Styles.label }, "Cardholder Name"),
                React.createElement("div", { className: Styles.cardHolderName }, name)),
            React.createElement("div", { className: Styles.item },
                React.createElement("div", { className: Styles.label }, "Credit Card Limit"),
                React.createElement("div", { className: Styles.creditCardLimit }, limit)),
            React.createElement("div", { className: Styles.item },
                React.createElement("div", { className: Styles.label }, "Expires"),
                React.createElement("div", { className: Styles.creditCardExpiry }, expiry)))));
};
export default CreditCardComponent;
